import {
  initialState,
  Actions,
  State,
  CHANGE_USER_EMAIL,
  CHANGE_USER_EMAIL_SUCCESS,
  CHANGE_USER_EMAIL_ERROR,
  RESET_CHANGE_USER_EMAIL,
} from "../../types/user/change-user-email";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CHANGE_USER_EMAIL:
      return {
        ...state,
        states: {
          success: false,
          loading: true,
          error: false,
        },
      };
    case CHANGE_USER_EMAIL_SUCCESS:
      return {
        ...state,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case CHANGE_USER_EMAIL_ERROR:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_CHANGE_USER_EMAIL:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
